/**
 * @fileoverview WEB-1197 — one source for the city-footer app band and the
 * DownloadAppStrip headline.
 *
 * CLT renders the issue strings verbatim. Other editions template the city
 * display name and the upper-case city code.
 */
import type { CityCode } from '@loci/city-editions';

/** Visible label on the app-band CTA. No trailing glyph. */
export const APP_BAND_CTA_LABEL = 'Open the app';

/** Band heading: `{City}, in your pocket.` */
export function appBandHeading(cityName: string): string {
  return `${cityName}, in your pocket.`;
}

/** Band body. `cityCode` is the upper-case edition code (for example `CLT`). */
export function appBandBody(cityCode: CityCode): string {
  return `Your saved spots and the reasons behind your picks, wherever you go in ${cityCode}.`;
}

/**
 * DownloadAppStrip default headline. The band heading plus the CTA label,
 * so the pocket line lives once: `Charlotte, in your pocket. Open the app.`
 */
export function appStripHeadline(cityName: string): string {
  return `${appBandHeading(cityName)} ${APP_BAND_CTA_LABEL}.`;
}
